
import { Art } from "@/utils/dto/art.js"
import ObjectSnippet from "@/components/objects/ObjectSnippet.vue";
import { STORAGE_IMAGE_PATH, STORAGE_BACKGROUND_PATH, BUILD_GENERAL_STORAGE_IMAGE_PATH } from "@/constants/ui.js";
import { trackHit } from "@/utils/helpers.js";
import ScoringModal from "@/components/objects/ScoringModal.vue";
import IconView from "@/components/objects/IconView.vue";
import TheBurgerMenu from "@/components/TheBurgerMenu.vue";
import VistatLogoAnimated from "@/components/base/VistatLogoAnimated.vue";
import LinkedObjectPublic from "@/components/LinkedObjectPublic.vue";

export default {
  name: "ArtSpDetail",
  components: { ObjectSnippet, ScoringModal, IconView, TheBurgerMenu, VistatLogoAnimated, LinkedObjectPublic },
  provide () {
    return {
      specialProject: true
    }
  },
  layout: "art_special_project",
  async asyncData({ params, store, error, redirect, $axios }) {
    const [artData] = await Promise.allSettled(
      [
        store.dispatch('art/publicObject', params['slug']),
      ]
    )

    // if (artData.status === 'rejected') {
    if (artData.status === 'rejected' || !artData.value) {
      return error({ statusCode: 404, humanReadableMessage: 'У нас нет такого материала. Но вы можете его создать!' })
    }

    if (params['slug'] !== artData.value.slug) {
      return redirect(`/art/${artData.value.slug}`);
    }

    return {
      artData: artData.value,
    }
  },
  data() {
    return {
      /** @type Art */
      object: {
        blocks: [],
        label: '',
        user: {
          id: '',
          profile: {
            about: '',
            icon: '',
            nickname: '',
            telegram_url: '',
            vk_url: ''
          },
          username: ''
        }
      },
      artData: {},
      comments: [],
      imagePath: [`${STORAGE_IMAGE_PATH}$id`, 'cover'],
      registerViewPromise: null,
      menuBgImage: null,
      textBgImage: null,
      bgImage: null,
      blockBgImages: [],
      isBurgerMenu: false,
      isSmall: false,
      scrolledY: false,
      scrolledFirstScreen: false,
      headerBgHeight: 84,
    }
  },

  head() {
    return {
      title: this.headTitle,
      meta: [
        { hid: 'description', name: 'description', content: this.headDescription },
        { hid: 'og:title', property: 'og:title', content: this.headTitle + '.' },
        { hid: 'og:image', property: 'og:image', content: this.headImage },
        { hid: 'og:type', property: 'og:type', content: 'article' },
        { hid: 'og:description', property: 'og:description', content: this.headDescription },
        { hid: 'og:site_name', property: 'og:site_name', content: 'ViStat.ORG - Интерактивная инфографика.' },
      ],
    }
  },
  computed: {
    STORAGE_IMAGE_PATH() {
      return STORAGE_IMAGE_PATH;
    },
    isStaging() {
      return process.env.isStaging
    },
    updatedAt() {
      const date = new Date(this.artData.updated_at)
      const day = date.getDate().toLocaleString('ru', { minimumIntegerDigits: 2 })
      const month = (date.getMonth() + 1).toLocaleString('ru', { minimumIntegerDigits: 2 })
      return `${day}.${month}.${date.getFullYear()}`
    },
    createdAt() {
      const date = new Date(this.artData.created_at)
      const day = date.getDate().toLocaleString('ru', { minimumIntegerDigits: 2 })
      const month = (date.getMonth() + 1).toLocaleString('ru', { minimumIntegerDigits: 2 })
      return `${day}.${month}.${date.getFullYear()}`
    },
    headTitle() {
      let title = this.object.label
      return title

    },
    headDescription() {
      let text = ''
      const blockWithText = this.artData.blocks.find(block => block.text)
      if (this.artData.sublabel) {
        const sublabel = this.artData.sublabel.split('.')
        text += `${sublabel[0]}. `
        text += sublabel[1] ? sublabel[1] : ''
      }
      if (blockWithText) {
        text += blockWithText.text.split('.')[0]
      }
      return text.replace(/[&\/\\#+()$~%'":*?<>{}\<p\>]/g, '') + '.'
    },
    headImage() {
      const blockWithImg = this.artData.blocks.find(block => block.type === 'image' && block.image)
      return blockWithImg ? this.$addServerPath(this.imagePath[0].replace('$id', blockWithImg.image.image_file)) : ''
    },
    menuPositionClass() {
      const menuPosition = this.object.spec_project_settings?.general_styles?.menu?.position;
      if (menuPosition) {
        return menuPosition;
      } else return null
    },
    menuBg() {
      const styles = this.object.spec_project_settings?.general_styles?.menu;
      const bgType = styles?.bg_type;
      const bgColor = styles?.bg_color;

      switch (bgType) {
      case 'color':
        return { backgroundColor: bgColor };
      case 'image':
      case 'bg-image':
        return { backgroundImage: `url(${this.menuBgImage})` };
      }
      return {}
    },
    headerBgStyles() {
      return {
        ...this.menuBg,
        height: `${this.headerBgHeight}px`,
      };
    },
    menuStyles() {
      const styles = this.object.spec_project_settings?.general_styles?.menu;
      const color = styles?.border_color ?? 'var(--gray)';
      const type = styles?.border_type;
      const radius = styles?.border_radius + 'px';
      const bgType = styles?.bg_type;
      const bgColor = styles?.bg_color;

      let bgStyles = {};
      switch (bgType) {
      case 'color':
        if (!this.scrolledFirstScreen) {
          bgStyles = { backgroundColor: bgColor };
        }
        break;
      case 'image':
      case 'bg-image':
        bgStyles = { backgroundImage: `url(${this.menuBgImage})` };
        break;
      }
      const allStyles = { borderRadius: radius, ...bgStyles, backgroundPosition: 'center' };

      switch (styles?.border_position) {
      case 'top-bottom':
        return { 'border-top': `3px ${type} ${color}`, 'border-bottom': `3px ${type} ${color}`, ...allStyles };
      case 'left-right':
        return { 'border-left': `3px ${type} ${color}`, 'border-right': `3px ${type} ${color}`, ...allStyles };
      case 'bottom':
        return { 'border-bottom': `3px ${type} ${color}`, ...allStyles };
      case 'all':
        return { border: `3px ${type} ${color}`, ...allStyles };
      case 'without-top':
        return { border: `3px ${type} ${color}`, 'border-top': 'none', ...allStyles };
      }

      return { ...allStyles };
    },
    bgStyles() {
      const styles = this.object.spec_project_settings?.general_styles?.background;
      const bgType = styles?.type;
      const bgColor = styles?.color;
      const bgOpacity = styles?.opacity === 100 ? '1' : `0.${styles?.opacity}`;

      switch (bgType) {
      case 'color':
        return { 'background-color': bgColor, opacity: bgOpacity };
      case 'image':
      case 'bg-image':
        if (this.bgImage) {
          const bgSize = styles?.size === 'attached' ? { 'background-size': 'cover', 'background-attachment': 'fixed' } : styles?.size === 'cover' ? { 'background-size': 'cover' } : { 'background-repeat': 'repeat' }
          return { 'background-image': `url(${this.bgImage})`, ...bgSize, backgroundPosition: 'center', opacity: bgOpacity };
        }
      }

      return {};
    },
    firstScreenPositionStyles() {
      const pos = this.object.spec_project_settings?.general_styles?.first?.position;

      switch (pos) {
      case 'left':
        return { textAlign: 'left', alignItems: 'flex-start' };
      case 'center':
        return { textAlign: 'center', alignItems: 'center' }
      case 'right':
        return { textAlign: 'right', alignItems: 'flex-end' }
      }

      return {};
    },
    firstScreenWidthStyles() {
      return { 'max-width': this.object.spec_project_settings?.general_styles?.first?.width ?? 'none' };
    },
    firstScreenBgStyles() {
      const styles = this.object.spec_project_settings?.general_styles?.first;
      const bgType = styles?.text_bg_type;
      const bgColor = styles?.text_bg_color;
      const radius = styles?.text_border_radius + 'px';

      let bgStyles = {};
      switch (bgType) {
      case 'color':
        bgStyles = { 'background-color': bgColor };
        break;
      case 'image':
      case 'bg-image':
        bgStyles = { 'background-image': `url(${this.textBgImage})` };
        break;
      }

      return { 'border-radius': radius, ...bgStyles };
    },
    firstScreenTextPadding() {
      return { padding: this.object.spec_project_settings?.general_styles?.first?.padding + 'px' };
    },
    firstScreenIconSizeStyles() {
      return { width: this.object.spec_project_settings?.general_styles?.first?.icon_size + 'px', height: this.object.spec_project_settings?.general_styles?.first?.icon_size + 'px' };
    },
    firstScreenH1ColorStyles() {
      return { color: this.object.spec_project_settings?.general_styles?.first?.h1_color };
    },
    firstScreenH2ColorStyles() {
      return { color: this.object.spec_project_settings?.general_styles?.first?.h2_color };
    },
    isShowImage() {
      return this.object.spec_project_settings?.general_styles?.first?.show_image === 'show';
    },
    menuFontColorStyles() {
      return { color: this.object.spec_project_settings?.general_styles?.menu?.font_color };
    },
    fontFamilyStyles() {
      return { fontFamily: this.object.spec_project_settings?.general_styles?.font?.family };
    },
    fontSizeStyles() {
      const style = this.object.spec_project_settings?.general_styles?.font;

      return {
        '--font-h1': (style?.h1 || 24) + 'px',
        '--font-h2': (style?.h2 || 20) + 'px',
        '--font-text': (style?.text || 16) + 'px',
        '--font-menu': (style?.menu || 14) + 'px'
      };
    },
    separatorStyles() {
      const styles = this.object.spec_project_settings?.general_styles?.menu;

      if (styles?.separator) {
        const iconUrl = this.$addServerPath(`/admin/icon_files/${styles?.separator}/picto_black/`)
        return {
          '--separator': `url("${iconUrl}")`
        }
      }
      return null;
    },
    isSmallDevice() {
      return this.isSmall;
    },
    fixedFirstScreenWidth() {
      return !this.firstScreenWidthStyles['max-width'].includes(['100%', 'none']);
    },
  },
  created() {
    this.object = new Art(this.artData, this.$store, true)
  },
  async mounted() {
    // document.querySelector('html').style.overflow = 'hidden auto';
    this.resizeHandler();
    this.scrollHandler();
    this.updateHeaderBgHeight();
    window.addEventListener('resize', this.resizeHandler);
    window.addEventListener('scroll', this.scrollHandler);
    // this.object = new Art(this.artData, this.$store, true);
    trackHit(this.$route.fullPath, this.headTitle, this.$route.meta.referer)
    this.registerViewPromise = setTimeout(() => {
      this.$store.dispatch('art/registerView', this.$route.params.slug)
    }, 3000);

    // Общий фон
    const bgStyles = this.object.spec_project_settings?.general_styles?.background;
    if (bgStyles?.type === 'image') {
      await this.$store.dispatch('backgrounds/fetchPublicObject', bgStyles?.image).then((item) => {
        this.bgImage = this.$addServerPath(`${STORAGE_BACKGROUND_PATH}{id}`.replace('{id}', item.picto));
      })
    } else if (bgStyles?.type === 'bg-image') {
      this.bgImage = BUILD_GENERAL_STORAGE_IMAGE_PATH(bgStyles?.image_2);
    }

    // Фон меню
    const menuStyles = this.object.spec_project_settings?.general_styles?.menu;
    if (menuStyles?.bg_type === 'image') {
      await this.$store.dispatch('backgrounds/fetchPublicObject', menuStyles?.bg_image).then((item) => {
        this.menuBgImage = this.$addServerPath(`${STORAGE_BACKGROUND_PATH}{id}`.replace('{id}', item.picto));
      })
    } else if (menuStyles?.bg_type === 'bg-image') {
      this.menuBgImage = BUILD_GENERAL_STORAGE_IMAGE_PATH(menuStyles?.bg_image_2);
    }

    // Фон текста на главном экране
    const firstScreenStyles = this.object.spec_project_settings?.general_styles?.first;
    if (firstScreenStyles?.text_bg_type === 'image') {
      await this.$store.dispatch('backgrounds/fetchPublicObject', firstScreenStyles?.text_bg_image).then((item) => {
        this.textBgImage = this.$addServerPath(`${STORAGE_BACKGROUND_PATH}{id}`.replace('{id}', item.picto));
      })
    } else if (firstScreenStyles?.text_bg_type === 'bg-image') {
      this.textBgImage = BUILD_GENERAL_STORAGE_IMAGE_PATH(firstScreenStyles?.text_bg_image_2);
    }

    // Фоны блоков
    if (this.object?.spec_project_settings?.blocks) {
      for await (let block of this.object.spec_project_settings.blocks) {
        if (block?.styles?.bg?.type === 'image') {
          await this.$store.dispatch('backgrounds/fetchPublicObject', block?.styles?.bg?.image).then((item) => {
            this.blockBgImages.push({
              id: block.id,
              image: this.$addServerPath(`${STORAGE_BACKGROUND_PATH}{id}`.replace('{id}', item.picto)),
            })
          })
        } else if (block?.styles?.bg?.type === 'bg-image') {
          this.blockBgImages.push({
            id: block.id,
            image: BUILD_GENERAL_STORAGE_IMAGE_PATH(block?.styles?.bg?.image_2),
          })
        }
      }
    }

    this.updateHeaderBgHeight();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeHandler);
    window.removeEventListener('scroll', this.scrollHandler);
    if (this.registerViewPromise) clearTimeout(this.registerViewPromise)
    this.registerViewPromise = null
  },
  methods: {
    getLinkUrl(id) {
      const block = this.object.spec_project_settings?.blocks?.find(block => block.id === id);

      if (block?.styles?.action?.url) {
        return block.styles?.action?.url;
      }

      return null
    },
    getLinkText(id) {
      const block = this.object.spec_project_settings?.blocks?.find(block => block.id === id);

      if (block?.styles?.action?.text) {
        return block.styles?.action?.text;
      }

      return null
    },
    getLinkStyles(id) {
      const block = this.object.spec_project_settings?.blocks?.find(block => block.id === id);

      if (block?.styles) {
        const styles = block.styles?.action;
        const textColor = styles?.text_color ?? '#1890ff';
        const bgColor = styles?.bg_color ?? 'transparent';
        const position = styles?.position;
        const alignPosition = position === 'left' ? {  marginRight: 'auto' } : position === 'right' ? { marginLeft: 'auto' } : { marginLeft: 'auto', marginRight: 'auto' };

        return { ...alignPosition, color: textColor, backgroundColor: bgColor };
      }

      return {};
    },
    getBlockStyles(id) {
      const blockStyle = this.blockBgImages.find(block => block.id === id)?.styles;
      return blockStyle ?? null;
    },
    getBlockParentStyles(id) {
      const block = this.object.spec_project_settings?.blocks?.find(block => block.id === id);

      if (block?.styles) {
        const borderStyles = block.styles?.border;
        const padding = borderStyles?.padding;
        const position = block.styles?.container?.position;
        const alignPosition = position === 'left' ? 'flex-start' : position === 'right' ? 'flex-end' : 'center';
        const blockWidth = block?.styles?.container?.width === 'none' ? {} : { maxWidth: block?.styles?.container?.width };

        return { ...blockWidth, padding: `${12 + padding}px ${20 + padding}px ${12 + padding}px ${20 + padding}px`, alignSelf: alignPosition };
      }

      return {};
    },
    getBlockBgStyles(id) {
      const block = this.object.spec_project_settings?.blocks?.find(block => block.id === id);

      if (block?.styles) {
        const borderStyles = block.styles?.border;
        const borderRadius = borderStyles?.border_radius ? { 'border-radius': borderStyles?.border_radius + 'px' } : {};
        const borderColor = borderStyles?.color ?? 'var(--gray)';
        const borderType = borderStyles?.type;
        const borderSize = borderStyles?.width;
        const image = this.blockBgImages.find(block => block.id === id)?.image;
        const styles = block.styles?.bg;
        const bgType = styles?.type;
        const bgColor = styles?.color;
        const cover = block.styles?.container?.cover;
        const position = block.styles?.container?.position;
        const blur = styles?.blur ? { 'filter': `blur(${styles?.blur}px)` } : {};

        let borderSettings = {};
        switch (borderStyles?.border_position) {
        case 'top-bottom':
          borderSettings = { 'border-top': `${borderSize}px ${borderType} ${borderColor}`, 'border-bottom': `${borderSize}px ${borderType} ${borderColor}` };
          break;
        case 'left-right':
          borderSettings = { 'border-left': `${borderSize}px ${borderType} ${borderColor}`, 'border-right': `${borderSize}px ${borderType} ${borderColor}` };
          break;
        case 'bottom':
          borderSettings = { 'border-bottom': `${borderSize}px ${borderType} ${borderColor}` };
          break;
        case 'all':
          borderSettings = { border: `${borderSize}px ${borderType} ${borderColor}` };
          break;
        case 'without-top':
          borderSettings = { border: `${borderSize}px ${borderType} ${borderColor}`, 'border-top': 'none' };
          break;
        }

        let bgStyles = {};
        const positionStyles = position === 'left' ? { left: '0', right: 'auto' } : position === 'right' ? { right: '0', left: 'auto' } : { left: '50%', right: 'auto', marginLeft: `calc(-50vw + ${this.isSmall ? '0px' : '8px'})` }
        const coverStyles = cover ? { ...positionStyles, width: `calc(100vw - ${this.isSmall ? '0px' : '16px'})`, height: '100%' } : {}
        switch (bgType) {
        case 'color':
          bgStyles = { 'background-color': bgColor };
          break;
        case 'image':
        case 'bg-image':
          const bgSize = styles?.size === 'attached' ? { 'background-size': 'cover', 'background-attachment': 'fixed' } : styles?.size === 'cover' ? { 'background-size': 'cover' } : { 'background-repeat': 'repeat' }
          bgStyles = image ? { 'background-image': `url(${image})`, ...bgSize, backgroundPosition: 'center' } : { };
          break;
        }

        return { ...borderRadius, ...borderSettings, ...blur, ...bgStyles, ...coverStyles };
      }

      return {};
    },
    scrollHandler() {
      this.scrolledY = window.scrollY > 0;
      this.scrolledFirstScreen = window.scrollY > this.$refs.objectHead?.clientHeight + 104;

      const prevIsBurgerMenu = this.isBurgerMenu;

      if (window.innerWidth < 959 && this.scrolledFirstScreen && this.object.spec_project_settings?.general_styles?.menu?.burger === 'scroll') {
        this.isBurgerMenu = true;
      } else if (window.innerWidth < 959 && this.object.spec_project_settings?.general_styles?.menu?.burger === 'always') {
        this.isBurgerMenu = true;
      } else {
        this.isBurgerMenu = false;
      }

      if (prevIsBurgerMenu !== this.isBurgerMenu) {
        this.$nextTick(() => {
          // this.updateFirstBlockHeight();
        });
      }

      this.updateHeaderBgHeight();
    },
    resizeHandler() {
      if (window.innerWidth < 959) {
        this.isSmall = true;

        if (this.object.spec_project_settings?.general_styles?.menu?.burger === 'scroll' && window.scrollY === 0) {
          this.isBurgerMenu = false;
        } else {
          this.isBurgerMenu = true;
        }
      } else {
        this.isBurgerMenu = false;
        this.isSmall = false;
      }

      // this.updateFirstBlockHeight();
      this.updateHeaderBgHeight();
    },
    updateHeaderBgHeight() {
      this.$nextTick(() => {
        const artHeadHeight = this.$refs.artHead?.getBoundingClientRect?.().height ?? 0;
        const topMenuHeight = this.$refs.topMenu?.getBoundingClientRect?.().height ?? 0;
        const stickyTopOffset = this.menuPositionClass === 'top' && !this.scrolledFirstScreen
          ? (window.innerWidth < 640 ? 20 : 20)
          : 14;

        this.headerBgHeight = Math.max(Math.ceil(artHeadHeight), Math.ceil(topMenuHeight)) + stickyTopOffset;
      });
    },
    updateFirstBlockHeight() {
      if (typeof window !== "undefined" && this.$refs.objectHead) {
        if (this.isShowImage) {
          if (window.innerWidth < 640) {
            this.$refs.objectHead.style.height = window.innerHeight - 40 - 64 + 4 + 'px'; // 4 это разница паддинг-топ от art-sp на мобилках
          } else { // 40 это высотка artHead
            this.$refs.objectHead.style.height = window.innerHeight - 40 - 64 + 'px'; // 64 это паддинги и маргины выше блока
          }
        }
      }
    },
    showScoring() {
      this.$vfm.show({
        component: ScoringModal,
        bind: {
          label: this.object.label,
          scoring_data: this.object.scoring_data,
          score: this.object.scoring_score ?? '-',
          total_score: this.object.total_score ?? '-',
        }
      })
    },
    scrollToBlock(id) {
      if (document.getElementById(`block-${id}`)) {
        document.getElementById(`block-${id}`).scrollIntoView({ block: "nearest", behavior: "smooth" });
      }
    },
    onLinkTag(event) {
      setTimeout(() => {
        this.$router.push({ name: 'sp-slug', params: { slug: this.$route.params.slug }, hash: event })
      }, 500)
    },
    blockId(label) {
      if (label) {
        return label.replaceAll(' ', '-').replaceAll('"', '').replaceAll(',', '');
      }

      return '';
    }
  },
}
